import { TableModel, ColumnModel } from './index';

export interface LocalTableModel {
	table: TableModel;
	columns: ColumnModel[];
}
